/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from "react";
import circlediagram from "../../../../public/media/images/circlediagram.png"
import { ElevatorPitchData, ElevatorPitchReportStakeholder, getElevatorPitchData } from '../../modules/project/core/_request'
import { IObjectiveArea } from '../../modules/core/_models'
import { useAuth } from "../../../app/modules/auth";
import { useParams } from "react-router-dom";
import { useSnackbar } from '../../../_theme/context/SnackbarContext'
import SimpleLoader from "../../modules/apps/components/SimpleLoader";
import { getApiErrorMessage, isForbiddenError } from "../../../utils/utils";
import NotFound from "../../modules/apps/components/NotFound";
import { isAbortedError } from "../../../utils/global";
import { getProjectStageLink } from "../../../utils/config";

const SinglePageReport = () => {

  const { project_id } = useParams()
  const { showSnackbar } = useSnackbar();
  const { auth } = useAuth();
  let user_id = auth?.user_id;
  const [loading, setLoading] = useState(true)
  const [accessDeniedMessage, setAccessDeniedMessage] = useState('')
  const [elevatorPitchData, setElevatorPitchData] = useState<ElevatorPitchData>({
    row_id: '',
    project_status: '',
    financial_needs: '',
    private_sector_opportunities: '',
    key_objectives_summary_editor: '',
    elevator_project_overview: '',
    estimated_years: 0,
    estimated_months: 0,
    estimated_project_start_date: '',
    project_type: '',
    project_size: '',
    project_name: '',
    estimated_cost: '',
    formatted_estimated_project_start_date: '',
  });
  const [objectives, setObjectives] = useState<IObjectiveArea[]>([]);
  const [keyParties, setkeyParties] = useState<ElevatorPitchReportStakeholder[]>([]);
  const [timelineData, settimelineData] = useState<
    { number: number, title: string; detail: string, status: string }[]
  >([]);
  const abortRef = useRef<AbortController | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      abortRef.current?.abort();
      const controller = new AbortController();
      abortRef.current = controller;

      try {
        const resp = await getElevatorPitchData({ project_id, user_id }, controller.signal)
        if (controller.signal.aborted) return;
        if (resp.errorCode === "FORBIDDEN") {
          setAccessDeniedMessage(resp.message || "Access denied. Elevator pitch is available only after Stage 4 is completed.")
        } else if (resp.status === "ok" && resp.data && !Array.isArray(resp.data)) {
          setElevatorPitchData((current) => ({
            ...current,
            ...resp.data.elevator_pitch_data,
            elevator_project_overview: resp.data.elevator_pitch_data?.elevator_project_overview || '',
          }));
          setObjectives(resp.data.objectives || []);
          setkeyParties(resp.data.identity_key_stakeholders || []);

          settimelineData(
            (resp.data.elevator_pitch_timeline || []).map(
              (item: { title: string; description: string }, index: number) => ({
                number: index + 1,
                title: item.title || "",
                detail: item.description || "",
                status: "active",
              })
            )
          );
        } else {
          showSnackbar(resp.message || "Failed to fetch data", "danger")
        }
      } catch (error) {
        if (isAbortedError(error)) return;
        if (isForbiddenError(error)) {
          setAccessDeniedMessage(getApiErrorMessage(error, "Access denied. Elevator pitch is available only after Stage 4 is completed."))
          return
        }
        console.error("Error fetching elevator pitch:", error)
        showSnackbar(getApiErrorMessage(error, "Something went wrong while fetching data"), "danger")
      } finally {
        if (!controller.signal.aborted) setLoading(false)
      }
    }


    fetchData()
    return () => abortRef.current?.abort();
  }, [project_id, showSnackbar, user_id])

  if (accessDeniedMessage) {
    return (
      <div
        className="d-flex flex-column flex-center"
        style={{ height: 'calc(100vh - var(--bs-app-header-height, 70px) - 4.5rem)' }}
      >
        <NotFound notFoundTitle="Access denied" notFoundText={accessDeniedMessage} homeButtonText="Return to Project Stages" homeButtonLink={`${getProjectStageLink(project_id || '')}`} />
      </div>
    )
  }

  return (
    <div className="single-page-report-div">
      <div className="position-relative">
       {loading && <SimpleLoader text="Loading..." className={"bg-black-30 z-2"} /> }
      <div className="title-section">
        <img src={circlediagram} className="circlediagram" alt="circle" />
        <div className="project_title">{elevatorPitchData.project_name}</div>
      </div>


      {/* First Row */}
      <div className="row">
        <div className="col-md-6">
          <div className="info-block">
            <div className="info-heading">
              PROJECT <br />SUMMARY
            </div>
            <div className="info-text" style={{ display: 'block' }}>
              <div>
                <strong className="mb-2 d-block">High-Level Project Overview</strong>
                <span
                  dangerouslySetInnerHTML={{
                    __html: elevatorPitchData.elevator_project_overview
                  }}
                />
              </div>

              {(objectives.length > 0 && !elevatorPitchData.key_objectives_summary_editor) && (
                <div className="mt-3">
                  <strong className="mb-2 d-block">Project Objectives & Focus Areas</strong>
                  <table className="table text-white">
                    <thead>
                      <tr style={{ borderBottom: 'solid 1px #e9e9e92b' }}>
                        <th>Objective</th>
                        <th>Key Focus Area</th>
                      </tr>
                    </thead>
                    <tbody>
                      {objectives.map((obj, index) => (
                        <tr key={obj.row_id ?? index}>
                          <td>{obj.objective_name}</td>
                          <td>{obj.keyFocus_name?.join(', ')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {elevatorPitchData.key_objectives_summary_editor && (
                <div className="mt-3">
                  <strong className="mb-2 d-block">Project Objectives Summary</strong>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: elevatorPitchData.key_objectives_summary_editor
                    }}
                  />
                </div>
              )}
              
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="info-block">
            <div className="info-heading">
              FINANCIAL <br />NEEDS
            </div>
            <div className="info-text" style={{ display: 'block' }}>
              <div>
                {/* {elevatorPitchData.project_type} : {elevatorPitchData.project_size} <br /> */}
                <span>
                  <b>Estimated cost :</b>{" "}
                  {elevatorPitchData.estimated_cost}
                </span>

              </div>
              {/* <hr /> */}
              <div className="mt-3">
                {/* <strong>Financial Needs</strong> */}
                <div
                  dangerouslySetInnerHTML={{
                    __html: elevatorPitchData.financial_needs
                  }}
                />
              </div>

            </div>
          </div>
        </div>
      </div>
      <hr />

      {/* PROJECT STATUS */}
      <div className="row">
        <div className="col-md-6">
          <div className="info-block">
            <div className="info-heading">
              PROJECT <br />STATUS
            </div>
            <div className="info-text"><div
              dangerouslySetInnerHTML={{
                __html: elevatorPitchData.project_status
              }}
            />
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="info-block">
            <div className="info-heading">
              PRIVATE <br />SECTOR<br />OPPORTUNITIES
            </div>
            <div className="info-text">
              <div
                dangerouslySetInnerHTML={{
                  __html: elevatorPitchData.private_sector_opportunities
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <hr />

      {/* Timeline */}
      <div className="row">
        <div className="col-md-12">

          {/* <div className="d-flex my-3" style={{ marginLeft: '160px' }}>
            <span>
              <b>Estimated Duration : </b> {elevatorPitchData?.estimated_years} Year(s) & {elevatorPitchData?.estimated_months} Month(s)
            </span>

            <span className="ms-3 ps-3 border-start">
              <b>Estimated Start Date : </b>{elevatorPitchData?.formatted_estimated_project_start_date}
            </span>
          </div> */}

          <div className="info-block">
            <div className="info-heading">TIMELINE</div>
            <div className="info-text timeline-report-info-text">
              <div className={`timeline-report ${timelineData.length === 1 ? 'single-step' : ''}`}>
                <div className="timeline-report-line-report"></div>
                <div className={`steps ${timelineData.length === 1 ? 'single-step' : ''}`}>
                  {timelineData.map((step, idx) => (
                    <div
                      className={`step ${step.status}`}
                      key={idx}
                    >
                      <div className="dot">{step.number}</div>
                      <div style={{ fontWeight: "bold" }} className="step-title">
                        {step.title}
                      </div>
                      <div className="step-detail">{step.detail}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />

      {/* Last Row */}
      <div className="row">
        <div className="col-md-12">
          <div className="info-block">
            <div className="info-heading">
              KEY <br />PARTIES
            </div>
            <div
              className="info-text"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center", // vertical center                
              }}
            >
              {keyParties.length > 0 && (
                <ul style={{ margin: 0 }}>
                  {keyParties.map((item, index) => (
                    <li key={item.stakeholder_id ?? index}>
                      <b>{item.stakeholder_name}</b>
                      {item.roles_and_responsibilities ? ` — ${item.roles_and_responsibilities}` : ''}
                    </li>
                  ))}
                </ul>
              )}
            </div>

          </div>
        </div>
      </div>
      </div>
    </div>
  );
}

export { SinglePageReport };